import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { space, borders, display, borderColor } from 'styled-system';
import { Classes, Dialog as BlueprintDialog } from '@blueprintjs/core';
import classNames from 'classnames';
import position from './utils/position';
import size from './utils/size';
import flex from './utils/flex';
import DialogBody from './DialogBody';
import DialogFooter from './DialogFooter';
const DialogStyled = styled(BlueprintDialog).withConfig({
  displayName: "Dialog__DialogStyled",
  componentId: "sc-27kxx9-0"
})(["&&{", ";", ";", ";", ";", ";", ";", ";", " ", " .", "{z-index:1;h4.", "{font-size:16px;}}}"], space, display, borders, borderColor, flex, position, size, ({
  top,
  maxHeight
}) => !maxHeight && css(["max-height:calc(100vh - ", "px);"], (top || 0) * 2 + 48), ({
  white,
  theme
}) => white && theme.name === 'light' && css(["background:", ";.", "{background:", ";border-bottom:", ";}.", "{padding-top:16px;background:", ";}"], theme.colors.appBackground, Classes.DIALOG_BODY, theme.colors.appBackground, theme.borders.thin, Classes.DIALOG_FOOTER, theme.colors.appBackground), Classes.DIALOG_HEADER, Classes.HEADING);
const DialogInner = ({
  children,
  className,
  tracker,
  canEscapeKeyClose = true,
  ...rest
}) => {
  const theme = useTheme();
  const dialogClassName = classNames(className, tracker);
  return /*#__PURE__*/React.createElement(DialogStyled, _extends({}, rest, {
    role: rest.role || 'dialog',
    canEscapeKeyClose: canEscapeKeyClose,
    className: dialogClassName,
    portalClassName: theme.name === 'dark' ? 'bp4-dark' : undefined
  }), children);
};
DialogInner.displayName = 'Dialog';
const Dialog = DialogInner;
Dialog.Body = DialogBody;
Dialog.Footer = DialogFooter;
export default Dialog;